import { createI18n } from 'vue-i18n'
import en from '../../locales/en.json'

let userLanguage = ''
let fallbackLanguage = ''

if (navigator.language.includes('fr')) {
  userLanguage = 'fr'
  fallbackLanguage = 'en'
}

if (navigator.language.includes('en')) {
  userLanguage = 'en'
  fallbackLanguage = 'fr'
}

if (userLanguage.length === 0 || fallbackLanguage.length === 0) {
  fallbackLanguage = 'en'
}

export { userLanguage, fallbackLanguage }

export default createI18n({
  locale: userLanguage,
  legacy: false,
  fallbackLocale: fallbackLanguage,
  warnHtmlMessage: false,
  messages: {
    fr: {
      event: {
        type: {
          success: 'Fonctionnement nominal',
          impactPartielPushOperateur:
            "Impact partiel sur le service Push en provenance d'opérateur(s)",
          impactPartielPushPsap:
            'Impact partiel sur le service Push à destination de PSAP',
          impactPartielPullOperateur:
            "Impact partiel sur le service Pull à destination d'opérateur(s)",
          impactPartielPullPsap:
            'Impact partiel sur le service Pull en provenance de PSAP',
          actionPflauSansImpact:
            'Actions planifiées par la PFLAU sans impact identifié',
          impactTotalPushOperateur:
            "Impact total sur le service Push en provenance d'opérateur(s)",
          impactTotalPushPsap:
            'Impact total sur le service Push à destination de PSAP',
          impactTotalPullOperateur:
            "Impact total sur le service Pull à destination d'opérateur(s)",
          impactTotalPullPsap:
            'Impact total sur le service Pull en provenance de PSAP',
          actionPflauAvecImpact:
            'Action planifiée par la PFLAU avec impact identifié',
          impactTotal: 'Impact total sur la PFLAU',
          notice: {
            global: 'Information générale'
          },
          maintenanceOperateur: {
            one: 'Maintenance déclarée par un opérateur',
            many: 'Maintenance déclarée par plusieurs opérateurs',
            all: 'Maintenance déclarée par tous les opérateurs'
          }
        },
        from: 'de',
        to: 'à',
        closedEvent: 'Cet événement est clos',
        MAJ: 'Evènement mis à jour'
      },
      application: {
        title: 'Administration PFLAU',
        loadingMsg: "Chargement de l'application...",
        contactEmail: "MTS.apnf.pflau.exploitation@magellangroup.eu"
      },
      messages: {
        info: {},
        requestError: {
          default:
            'Une erreur est survenue pendant le chargement. Veuillez réessayer plus tard.',
          '0': 'Le serveur ne répond pas. Veuillez réessayer plus tard.',
          '503': 'Le serveur ne répond pas. Veuillez réessayer plus tard.',
          '403':
            "Vous n'avez pas l'autorisation pour consulter ceci. Vérifiez que vous êtes connecté.",
          '404': 'Un problème est survenu pour retrouver les informations.',
          '400': "Une erreur s'est produite.",
          '500': "Une erreur s'est produite."
        },
        error: {
          unauthorizedState:
            "Vous n'avez pas la permission d'accèder à cette partie de l'interface"
        }
      },
      modules: {
        'pflau-grid-list': {
          messages: {
            requestError: {
              default: 'Un problème est survenu pour récupérer la liste',
              '404': "Le listing que vous demandez n'existe pas."
            }
          }
        }
      },
      global: {
        browsehappy:
          'Vous utilisez un <strong>ancien</strong> navigateur. Veuillez <a href="http://browsehappy.com/?locale=fr">mettre à jour votre navigateur</a> pour une meilleure expérience.',
        sectionMenu: {
          psap: 'Psap',
          operator: 'Opérateur',
          admin: 'Admin',
          docs: 'Liens utiles'
        },
        infos_psap: 'Informations du Psap',
        gestion_users: 'Gestion des utilisateurs',
        itemMenu: {
          myPsapInfos: 'Infos Psap',
          myOperatorInfos: "Détail de l'Opérateur",
          myPsapRecevability: 'Recevabilité de mon Psap',
          fullPsapList: 'Liste complète',
          operatorMaintenance: 'Déclarer une maintenance',
          myPsapAttached: 'Psaps rattachés',
          attachPsap: 'Rattacher un Psap',
          mep: 'Mise en production des PSAPs',
          manageMyPsapUsers: 'Gérer les utilisateurs',
          manageAllUsers: 'Gestion des utilisateurs',
          addUser: 'Créer un utilisateur',
          manageIntegratorUsers: 'Gestion des intégrateurs',
          manageMinisterManager: 'Gestion des Chefs de projet Ministère',
          sectionDocs: {
            doc: 'Documentation',
            cgu: 'CGU',
            faq: 'FAQ',
            logs: 'Logs du service',
            support_incident: "Support dédié et déclaration d'incident"
          },
          statistics: 'Statistiques',
          monthlyStatistics: 'Statistiques mensuelles',
          stateAutority: "Autorité d'état",
          createUsers: 'Création comptes utilisateurs',
          refreshCacheForPull: 'Mise à jour du cache des CN pour le pull',
          psapRecord: 'Détail du Psap',
          operatorRecord: 'Fiche opérateur',
          userRecord: 'Fiche utilisateur',
          newOperator: "Création d'un opérateur",
          newUser: "Création d'un utilisateur",
          'user-detail': "Détail de l'utilisateur",
          me: 'Paramètres du compte',
          events: 'Gérer les évènements',
          horairesSVH: 'Horaires SVH',
          factu: 'Facturations'
        },
        navBar: {
          deconnexion: {
            title: 'Déconnexion',
            tooltip: 'Se déconnecter'
          },
          help: {
            title: 'FAQ',
            tooltip: 'Vous vous posez une question ? Cliquez ici'
          },
          support: {
            title: 'Support dédié',
            tooltip: 'Vous souhaitez obtenir une aide personnalisée ?'
          },
          profile: {
            title: 'Compte',
            tooltip: 'Gérer mes informations utilisateur'
          },
          recevabilite: {
            title: 'Recevabilité',
            tooltip: 'Retour aux étapes de recevabilité'
          },
          docGuide: {
            title: 'Documentation',
            tooltip: 'Récupérer la documentation'
          }
        },
        'dismiss-alert': {
          close: 'Fermer'
        },
        popup: {
          info: {
            cancelButton: 'Annuler'
          },
          confirm: {
            okButton: 'OK',
            cancelButton: 'Annuler'
          }
        },
        language: {
          en: 'Anglais',
          fr: 'Français'
        },
        form: {
          username: "Nom d'utilisateur",
          'username.placeholder': "Votre nom d'utilisateur",
          newPassword: 'Nouveau mot de passe',
          'newPassword.placeholder': 'Nouveau mot de passe',
          confirmPassword: 'Confirmation du nouveau mot de passe',
          'confirmPassword.placeholder': 'Confirmation du nouveau mot de passe',
          email: 'Email',
          'email.placeholder': 'Votre email'
        },
        messages: {
          info: {
            authenticated: 'Bienvenue sur la plateforme'
          },
          error: {
            pwdDontMatch:
              'Le nouveau mot de passe et sa confirmation ne sont pas égaux !'
          },
          validate: {
            newPassword: {
              required: 'Votre mot de passe est requis.',
              minlength:
                'Votre mot de passe doit comporter au moins 5 caractères.',
              maxlength:
                'Votre mot de passe ne doit pas comporter plus de 50 caractères.',
              strength: 'Robustesse du mot de passe :'
            },
            confirmPassword: {
              required: 'Votre confirmation du mot de passe est requis.',
              minLength:
                'Votre confirmation du mot de passe doit comporter au moins 5 caractères.',
              maxLength:
                'Votre confirmation du mot de passe ne doit pas comporter plus de 50 caractères.'
            },
            email: {
              required: 'Votre email est requis.',
              minLength: 'Votre email doit comporter au moins 5 caractères.',
              maxLength:
                'Votre email ne doit pas comporter plus de 50 caractères.',
              invalid: "Votre email n'est pas valide."
            },
            generic: {
              required: 'Ce champ est requis.',
              invalid: 'La saisie est incorrect'
            }
          }
        }
      },
      main: {
        logged: {
          message: 'Vous êtes connecté en tant que "{{username}}".'
        },
        footer: 'Ceci est votre pied de page',
        copyright: 'Copyright '
      },
      login: {
        title: 'Authentification',
        form: {
          password: 'Mot de passe',
          'password.placeholder': 'Votre mot de passe',
          rememberMe: 'Garder la session ouverte',
          button: 'Connexion'
        },
        messages: {
          error: {
            authentication:
              "<strong>Erreur d'authentification!</strong> Veuillez vérifier vos identifiants de connexion.",
            gdpr: "Si vous continuez à naviguer sur notre site, vous acceptez que vos actions soient loggées. Il vous est possible de nous contacter à l'adresse <a href='mail:EMAIL@magellangroup.eu'>EMAIL@magellangroup.eu</a> afin de consulter et/ou supprimer ces informations."
          }
        }
      },
      profile: {
        title: 'Profile',
        tooltip: 'Gérer mon profil utilisateur [{{username}}]',
        form: {
          firstname: 'Prénom',
          'firstname.placeholder': 'Votre prénom',
          lastname: 'Nom',
          'lastname.placeholder': 'Votre nom',
          button: 'Enregistrer'
        },
        messages: {
          error:
            '<strong>Une erreur est survenue !</strong> Votre profil ne peut pas être sauvegardé.',
          success: '<strong>Votre profil a été sauvegardé !</strong>',
          validate: {
            firstname: {
              required: 'Votre prénom est requis.',
              minLength: 'Votre prénom doit comporter au moins un caractère.',
              maxLength:
                'Votre prénom ne doit pas comporter plus de 50 caractères.'
            },
            lastname: {
              required: 'Votre nom est requis.',
              minLength: 'Votre nom doit comporter au moins un caractère.',
              maxLength:
                'Votre nom ne doit pas comporter plus de 50 caractères.'
            }
          }
        }
      },
      changePassword: {
        title: 'Changer mon mot de passe [<strong>{{username}}</strong>]',
        form: {
          button: 'Sauvegarder'
        },
        messages: {
          error:
            "<strong>Une erreur est survenue !</strong> Le mot de passe n'a pas pu être modifié.",
          success: '<strong>Le mot de passe a été modifié !</strong>'
        }
      },
      errors: {
        title: "Page d'erreur !",
        '403': "Vous n'avez pas les droits pour accéder à cette page."
      },
      psapList: {
        all: {
          title: 'Liste des Psaps'
        },
        integratorAttached: {
          title: 'Liste des Psaps rattachés'
        },
        inService: {
          title: 'Liste des Psaps en service'
        },
        ministerAttached: {
          title: 'Liste des Psaps rattachés'
        },
        form: {
          exemple: 'exemple',
          'exemple.placeholder': 'exemple'
        },
        messages: {
          error: {
            exemple: 'exemple'
          }
        }
      },
      support: {
        title: 'Support dédié'
      },
      userList: {
        all: {
          title: 'Liste des utilisateurs'
        },
        integrators: {
          title: 'Liste des intégrateurs'
        },
        ministerManagers: {
          title: 'Liste des Chefs de projet Ministère'
        },
        stateAuthority: {
          title: "Liste des autorités d'État"
        },
        form: {
          exemple: 'exemple',
          'exemple.placeholder': 'exemple'
        },
        messages: {
          error: {
            exemple: 'exemple'
          }
        }
      },
      psapToAttachList: {
        title: 'Liste des Psaps à rattacher',
        form: {
          exemple: 'exemple',
          'exemple.placeholder': 'exemple'
        },
        actions: {
          attachPsap: {
            button: 'Rattacher',
            'button.helper': 'Devenir intégrateur de ce Psap',
            confirmTitle: 'Confirmer le rattachement',
            confirmMessageIntegrator:
              'Vous allez devenir intégrateur du Psap. Pour continuer, veuillez également sélectionner le chef de projet ministère en charge de ce Psap.',
            confirmMessage:
              "Vous allez attacher l'intégrateur du Psap. Vous devez également sélectionner le chef de projet ministère en charge de ce Psap.",
            form: {
              'ministerProjectChief.helper':
                'Sélectionner le chef de projet ministère à affecter à ce Psap'
            },
            messages: {
              validate: {
                ministerProjectChief: {
                  required: 'Veuillez sélectionner un chef de projet Ministère.'
                }
              },
              error: {
                psapLoadFail: 'Erreur de chargement du Psap',
                projectChiefsLoadFail:
                  'Impossible de charger la liste des chefs de projet ministère',
                initiatePsapFail:
                  'Un problème est survenu durant la mise à jour du Psap.'
              }
            }
          }
        },
        messages: {
          error: {
            exemple: 'exemple'
          }
        }
      },
      attachMyPsap: {
        title: 'Attacher mon Psap',
        confirmTitle: 'Confirmer le rattachement',
        htmlExplanation:
          "Aucun intégrateur n'est pour le moment affecté à votre Psap.<br />Si vous le souhaitez, vous pouvez devenir votre propre intégrateur. Pour confirmer cela et continuer, veuillez également sélectionner le chef de projet ministère en charge de ce Psap.<br />Il vous sera toujours possible de changer d'intégrateur après les différentes phases de recevabilité.",
        form: {
          integrator: 'Intégrateur',
          'integrator.helper': "Sélectionner l'intégrateur affecté à ce Psap",
          ministerProjectChief: 'Chef de projet ministère',
          'ministerProjectChief.helper':
            'Sélectionner le chef de projet ministère à affecter à ce Psap',
          okButton: 'Enregistrer et continuer'
        },
        messages: {
          validate: {
            ministerProjectChief: {
              required: 'Veuillez sélectionner un chef de projet Ministère.'
            }
          },
          error: {
            psapLoadFail: 'Erreur de chargement de votre Psap',
            projectChiefsLoadFail:
              'Impossible de charger la liste des chefs de projet ministère',
            initiatePsapFail:
              'Un problème est survenu durant la mise à jour du Psap.'
          }
        }
      },
      'users-creation': {
        messages: {
          howToUseDropzone:
            "<span><span class='material-icons' aria-hidden='true'>info</span>Sélectionnez un fichier CSV pour créer des comptes utilisateurs<br /><span class='material-icons' aria-hidden='true'>info</span>Seulement un fichier de type CSV est accepté. La première ligne de votre fichier CSV doit contenir les titres dans cet ordre : PSAP logique, Profil compte, Login, Nom, Prénom, Contact mail.<br /><br />Un contrôle sera appliqué sur les comptes utilisateurs que vous souhaitez créer. Un tableau s'affichera sur la page récapitulant les détails de chaque compte. Dans le cas d'un compte utilisateur ne validant pas tous les prérequis, vous trouverez l'explication des champs erronés dans le tableau. Vous pourrez ensuite corriger votre fichier et le re-uploader sur la page. Dans le cas où les comptes erronés ne sont pas modifiés, seuls les comptes valides seront créés suite au clic sur le bouton \"Créer utilisateurs\"<br /><br /><span class='material-icons' aria-hidden='true'>warning</span>Cette page permet de créer des utilisateurs ayant les profiles suivants : PSAP, PSAP_MANAGER, OPERATOR et OPERATOR_MANAGER.<br /> Pour tout autre type de profil, veuillez utiliser le formulaire sous Admin -> Gestion des utilisateurs -> créer un utilisateur </span>",
          success: 'Utilisateurs crées avec succes',
          information:
            "<span><span class='material-icons' aria-hidden='true'>info</span> Information : Seuls les comptes valides seront crées</span>"
        },
        button: {
          create: 'Créer utilisateurs'
        },
        title: 'Créer des comptes utilisateurs'
      },
      'ismp-sd': {
        messages: {
          welcome:
            "En cas d'incident constaté sur la PFLAU veuillez :<br /><br /><ol><li>Contrôler l'état du service PFLAU au travers de cette IHM. Une météo verte traduit, a priori, d'un fonctionnement nominal de la plateforme.</li><li>&Agrave; défaut vous pouvez contacter l'exploitation de Worldline au 09 69 37 24 24 (numéro de téléphone joignable 24h/24, 7j/7).</li><li>En heures ouvrées (9h-18h heure de Paris, du lundi au vendredi, hors jours fériés) la mailing liste de l'équipe sera la plus indiquée pour traiter votre demande : MTS.apnf.pflau.exploitation@magellangroup.eu.</li></ol>"
        },
        title: 'Déclarer un incident'
      },
      'new-operator': {
        tooltip: {
          opta: "Cochez cette case si l'opérateur joue le rôle d'OPTA pour d'autres opérateurs",
          svh: "Cochez cette case si l'opérateur est SVH"
        }
      },
      operatorList: {
        title: 'Liste des Opérateurs'
      },
      operatorMaintenance: {
        title: 'Maintenance'
      },
      'refresh-cache-cn-for-pull': {
        title: 'Purger et afficher le cache des CN du service PULL'
      },
      monthlyStatistics: {
        messages: {
          welcome:
            'Afin de consulter les statistiques mensuelles du service, merci de vous rendre sur le portail ISMP :'
        },
        title: 'Statistiques mensuelles du service'
      },
      'factu-zip': {
        messages: {
          welcome: 'Facturation'
        },
        title: 'Facturation'
      },
      logs: {
        generate: {
          success:
            'Le fichier de log {{filename}} a été généré. Il sera déposé sur le SFTP.',
          error:
            'Une erreur est survenue lors de la génération des logs. Veuillez réessayer ultérieurement.',
          notFound: "Le fichier de log {{service}} du {{date}} n'existe pas."
        }
      },
      recevability: {
        global: {
          cgu: {
            warningNotContractualTitle: 'Valeur juridique',
            warningNotContractual:
              "Avant de continuer, veuillez savoir que valider ces CGU n'est pas recevable juridiquement. Cela ne dispense pas de finaliser avec une contractualisation entre les deux parties via un moyen tier."
          },
          button: {
            prev: {
              title: 'Etape précédente',
              tooltip: "Consulter l'étape précédente"
            },
            next: {
              title: 'Etape suivante',
              tooltip: "Passer à l'étape suivante"
            },
            validate: {
              title: "Valider l'étape",
              tooltip: "Valider et passer à l'étape suivante"
            }
          }
        },
        psap: {
          one: {
            title: 'Recevabilité du Psap {{name}}'
          },
          documentation: {
            support: {
              message:
                "<span><span class='material-icons head-ico'>chat_bubble</span> Si vous le souhaitez, Worldline (MTS.apnf.pflau.exploitation@magellangroup.eu) peut vous fournir une assistance personnalisée afin de réaliser votre recevabilité.<br />Toute  demande  fera  l'objet  d'une  étude  de  charge  et  de  planning  par  Worldline  qui  prendra  en compte la disponibilité des ressources nécessaires au moment de la sollicitation.</span>"
            }
          },
          mine: {
            title: 'Recevabilité du Psap'
          },
          svh: {
            title: 'Recevabilité SVH du Psap'
          },
          messages: {
            validate: {
              toNextStage: {
                mustValidateCurrent:
                  "Veuillez d'abord valider cette étape avant de passer à la suivante"
              }
            },
            success: {
              recevabilityValidated:
                'Vous avez bien validé la dernière étape de la recevabilité du Psap.'
            },
            info: {
              recevabilityAlreadyDone:
                'Les étapes de recevabilité du Psap sont terminées. Vous pouvez seulement la consulter.'
            },
            error: {
              psapIdNotFound: 'Accès non autorisé',
              psapNotExists: "Le Psap n'existe pas",
              stagesLoadFail:
                'Un problème est survenu durant le chargement des étapes de recevabilité. Veuillez réessayer.',
              psapLoadFail:
                'Un problème est survenu durant le chargement des informations du Psap . Veuillez réessayer.',
              recevabilityLoadFail:
                'Un problème est survenu durant le chargement de la recevabilité du Psap . Veuillez réessayer. (#102)',
              recevabilityLoadFailAfterCreate:
                'Un problème est survenu durant le chargement de la recevabilité du Psap . Veuillez réessayer. (#101)',
              noRecevabilityInProgress:
                "Le Psap n'est pas en cours de recevabilité. Un intégrateur Psap doit d'abord initialiser le processus.",
              cannotRemoveRecevability:
                'Vous avez bien validé la dernière étape de la recevabilité du Psap. (#100)',
              cannotValidateCurrentStage:
                "Un problème est survenu pour passer à l'étape suivante. Veuillez réessayer."
            }
          },
          step: {
            WAITING_CGU_VALIDATION: {
              timelineTitle: 'CGU',
              title: 'Validation des CGU',
              subTitle: "Conditions Générales d'Utilisation",
              htmlStepUnauthorized:
                "L'acceptation des CGU est réalisée par le Psap ou l'intégrateur affecté à ce Psap.<br />Veuillez patienter jusqu'à la validation de l'étape.",
              form: {
                userAgreedCGU:
                  "Oui, j'ai lu et j'accepte les Conditions Générales d'Utilisation du service",
                'userAgreedCGU.helper':
                  'Veuillez cocher la case pour accepter les CGU.'
              },
              messages: {
                validate: {
                  userAgreedCGU: {
                    required: ''
                  }
                },
                info: {
                  cguToRead:
                    "Veuillez lire puis accepter les conditions générales d'utilisation du service avant de poursuivre."
                },
                error: {
                  formInvalid:
                    'Veuillez accepter les CGU si vous souhaitez continuer.'
                },
                success: {
                  formValidated: "CGU acceptées. Passage à l'étape suivante."
                }
              }
            },
            WAITING_INFOS_SSL: {
              timelineTitle: 'INFOS SSL',
              title: 'Informations SSL',
              warningSvhModif:
                'Attention les paramètres de cette page sont communs avec les services hors SVH. Le fait de modifier les informations ici, modifie également les données de vos autres services.',
              htmlExplanation:
                "Veuillez renseigner les coordonnées du contact projet, du contact technique et du chef de projet ministère. Remplissez ensuite les informations demandées sur les caractéristiques du SSL à mettre en place.<br />Terminez ensuite en indiquant les URL d'accès aux pages de tests puis valider le formulaire pour les envoyer à Worldline.",
              htmlStepUnauthorized:
                "La configuration des informations SSL est réalisée par le Psap ou l'intégrateur affecté à ce Psap.<br />Veuillez patienter jusqu'à la validation de l'étape.",
              form: {
                projectContactSectionTitle:
                  'Coordonnées du contact projet (MOA)',
                projectContactName: 'Nom',
                projectContactNamePlaceholder: {
                  placeholder: 'Nom du contact projet'
                },
                projectContactPhone: 'Téléphone',
                projectContactPhonePlaceholder: {
                  placeholder: 'Téléphone du contact projet'
                },
                projectContactFax: 'Fax (facultatif)',
                projectContactFaxPlaceholder: {
                  placeholder: 'Fax du contact projet'
                },
                'projectContactFax.empty': '-',
                projectContactMail: 'Email',
                projectContactMailPlaceholder: {
                  placeholder: 'Email du contact projet'
                },
                technicalContactSectionTitle:
                  'Coordonnées du contact technique',
                technicalContactName: 'Nom',
                technicalContactNamePlaceholder: {
                  placeholder: 'Nom du contact technique'
                },
                technicalContactPhone: 'Téléphone',
                technicalContactPhonePlaceholder: {
                  placeholder: 'Téléphone du contact technique'
                },
                technicalContactFax: 'Fax (facultatif)',
                technicalContactFaxPlaceholder: {
                  placeholder: 'Fax du contact technique'
                },
                'technicalContactFax.empty': '-',
                technicalContactMail: 'Email',
                technicalContactMailPlaceholder: {
                  placeholder: 'Email du contact technique'
                },
                ministerProjectChiefSectionTitle:
                  'Coordonnées du contact chef de projet ministère',
                ministerProjectChiefName: 'Nom',
                'ministerProjectChiefName.placeholder':
                  'Nom du contact ministère',
                ministerProjectChiefPhone: 'Téléphone',
                'ministerProjectChiefPhone.placeholder':
                  'Téléphone du contact ministère',
                ministerProjectChiefFax: 'Fax (facultatif)',
                'ministerProjectChiefFax.placeholder':
                  'Fax du contact ministère',
                'ministerProjectChiefFax.empty': '-',
                ministerProjectChiefMail: 'Email',
                'ministerProjectChiefMail.placeholder':
                  'Email du contact ministère',
                technicalInfosSectionTitle: 'Informations techniques',
                technicalInfosRootCertifAuthority: 'Autorité de certification',
                'technicalInfosRootCertifAuthority.helper':
                  "Sélectionner l'autorité de certification correspondant à votre certificat SSL",
                resetUrlCrl: 'Remettre les URL par défaut',
                'resetUrlCrl.helper':
                  "Réinitialiser la liste d'URL avec les URL par défaut de l'autorité de certification sélectionnée",
                technicalInfosUrlCrlList: 'Liste des URL CRL',
                urlCrlPlaceholder: { placeholder: 'Indiquez une URL' },
                'urlCrl.helper':
                  "Modifier selon vos besoins les URL en respectant l'ordre",
                addUrlCrl: 'Ajouter une URL',
                'addUrlCrl.helper':
                  'Ajouter une URL CRL supplémentaire à la liste',
                removeUrlCrl: 'Supprimer',
                'removeUrlCrl.helper': 'Supprimer cette URL de la liste',
                technicalInfosProdIpRangeSource:
                  "Plage(s) d'Ip sources en production",
                technicalInfosProdIpRangeSourcePlaceholder: {
                  placeholder: "Plage(s) d'Ip sources en production"
                },

                'technicalInfosProdIpRangeSource.helper':
                  "Indiquez une ou plusieurs Ip ou plage d'Ip séparées par des point-virgules",
                otherSectionTitle: 'Instructions',
                comments: 'Commentaires utiles',
                commentsPlaceholder: {
                  placeholder: 'Indiquez ici tout commentaires utiles'
                },
                'comments.helper':
                  'Indiquez tout ce qui peut être utile pour la mise en place du SSL',
                testUrlSectionTitle: "URL d'accès webservice",
                prodTestUrl: 'URL de PUSH utilisé pour la recevabilité',
                'prodTestUrl.placeholder':
                  'Indiquez le lien vers la page de test',
                'prodTestUrl.helper':
                  'Renseignez une adresse commençant par https://',
                technicalInfosCommonName:
                  'Common Name du certificat client PULL',
                'technicalInfosCommonName.helper':
                  'Veuillez indiquer la valeur du champ CN de votre certificat de production'
              },
              messages: {
                validate: {
                  projectContactName: {
                    required: 'Veuillez indiquer le nom du contact projet',
                    invalid: 'Veuillez indiquer un nom plus court'
                  },
                  projectContactPhone: {
                    required:
                      'Veuillez indiquer le téléphone du contact projet',
                    invalid:
                      'Veuillez indiquer un téléphone au format 0123456789 ou +33123456789'
                  },
                  projectContactFax: {
                    invalid:
                      'Veuillez indiquer un fax au format 0123456789 ou +33123456789'
                  },
                  projectContactMail: {
                    required:
                      "Veuillez indiquer l'adresse email du contact projet",
                    invalid: 'Veuillez indiquer une adresse email correcte'
                  },
                  technicalContactName: {
                    required: 'Veuillez indiquer le nom du contact technique',
                    invalid: 'Veuillez indiquer un nom plus court'
                  },
                  technicalContactPhone: {
                    required:
                      'Veuillez indiquer le téléphone du contact technique',
                    invalid:
                      'Veuillez indiquer un téléphone au format 0123456789 ou +33123456789'
                  },
                  technicalContactFax: {
                    invalid:
                      'Veuillez indiquer un fax au format 0123456789 ou +33123456789'
                  },
                  technicalContactMail: {
                    required:
                      "Veuillez indiquer l'adresse email du contact technique",
                    invalid: 'Veuillez indiquer une adresse email correcte'
                  },
                  ministerProjectChiefName: {
                    required: 'Veuillez indiquer le nom du contact ministère',
                    invalid: 'Veuillez indiquer un nom plus court'
                  },
                  ministerProjectChiefPhone: {
                    required:
                      'Veuillez indiquer le téléphone du contact ministère',
                    invalid:
                      'Veuillez indiquer un téléphone au format 0123456789 ou +33123456789'
                  },
                  ministerProjectChiefFax: {
                    invalid:
                      'Veuillez indiquer un fax au format 0123456789 ou +33123456789'
                  },
                  ministerProjectChiefMail: {
                    required:
                      "Veuillez indiquer l'adresse email du contact ministère",
                    invalid: 'Veuillez indiquer une adresse email correcte'
                  },
                  technicalInfosRootCertifAuthority: {
                    required:
                      'Veuillez sélectionner votre autorité de certification'
                  },
                  urlCrl: {
                    required: 'Veuillez indiquer une URL',
                    invalid: 'Veuillez indiquer une URL valide'
                  },
                  technicalInfosQualifIpRangeSource: {
                    required:
                      "Veuillez saisir une suite d'Ip ou de plages d'Ip séparées par des points-virgules",
                    invalid:
                      "Veuillez saisir une suite d'Ip ou de plages d'Ip valides séparées par des points-virgules. Par exemple : 123.123.12.12; 123.123.13.1/24"
                  },
                  technicalInfosProdIpRangeSource: {
                    required:
                      "Veuillez saisir une suite d'Ip ou de plages d'Ip séparées par des points-virgules",
                    invalid:
                      "Veuillez saisir une suite d'Ip ou de plages d'Ip valides séparées par des points-virgules. Par exemple : 123.123.12.12; 123.123.13.1/24"
                  },
                  qualifTestUrl: {
                    required:
                      "Veuillez saisir l'adresse https d'accès à la page de test de qualification",
                    invalid:
                      'Veuillez saisir une adresse https correcte. Exemple: http://mondomaine.fr/chemin/vers/la/page.html'
                  },
                  prodTestUrl: {
                    required:
                      "Veuillez saisir l'adresse https d'accès à la page de test de production",
                    invalid:
                      'Veuillez saisir une adresse https correcte. Exemple: http://mondomaine.fr/chemin/vers/la/page.html',
                    notAccessible:
                      "Cette URL n'est pas accessible, veuillez saisir une URL de push accessible"
                  }
                },
                info: {
                  xx: 'xx'
                },
                error: {
                  sslInfoLoadFail:
                    'Une erreur est survenue lors du chargement du formulaire. Veuillez réessayer dans un moment',
                  formInvalid:
                    'Veuillez vérifier les données saisies dans le formulaire'
                },
                success: {
                  formValidated:
                    "Les informations SSL ont bien été enregistrées. Passage à l'étape suivante."
                }
              }
            },
            CONFIG_SSL: {
              timelineTitle: 'Conf SSL',
              title: 'Configuration SSL',
              htmlStepUnauthorized:
                "Cette étape est réalisée par Worldline.<br />Vos contacts technique et projet seront notifiés par mail une fois l'étape terminée.",
              button: {
                copyCnInBdd: {
                  title: 'Enregistrer CN',
                  tooltip:
                    'Enregistrer le Common Name du certificat pull dans la BDD'
                }
              }
            },
            TERMINAL_LOCALISATION_PULL_SVH_TEST: {
              timelineTitle: 'Demande Localisation',
              title: 'Test de demande localisation',
              htmlExplanation:
                "Veuillez envoyer un localisation depuis votre plateforme puis actualiser la liste des logs ci-dessous en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              htmlStepUnauthorized:
                "La demande de localisation est réalisé par le Psap ou l'intégrateur affecté à ce Psap.<br />Veuillez patienter jusqu'à la validation de l'étape.",
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                success: {
                  alreadyValidated: 'Cette étape à déjà été validée',
                  lastTestOk: '- Le dernier test effectué est réussi',
                  transIdUnique:
                    '- La valeur de TransId est différente pour chaque test',
                  transIdValid: '- Les TransId respectent la bonne syntaxe',
                  dateEnvoiReceptionReqValid:
                    "- Ecart de moins de 10s entre l'horaire de l'appel du service localisation et l'horaire de réception effectif",
                  OkAndKo: '- Il existe au moins un test OK et un test KO',
                  PermissionValidation:
                    "<span><span class='material-icons' aria-hidden='true'>check</span> Vous pouvez valider l'étape</span>"
                },
                warning: {
                  lastTestKo: "- Le dernier test doit avoir le statut 'OK'",
                  transIdNotUnique:
                    '- Le TransId doit avoir des valeurs différentes pour chaque test',
                  transIdNotValid:
                    "- Ces TransId ne respectent pas la bonne syntaxe. Pour plus d'informations à propos du TransId, veuillez consulter la <a href='#/faq#syntaxeTransId'>FAQ</a>",
                  dateEnvoiReceptionReqNotValid:
                    "- Un écart de plus de 10s entre<br />--> <strong>Date requête (UTC)</strong> correspondant à la date que vous envoyez lors de l'appel du service localisation<br /> --> et <strong>Date serveur PFLAU (UTC)</strong> correspondant à la date de réception effective de la requête<br /> Merci de verifier l'heure que vous envoyez lors de l'appel du service localisation.",
                  OkAndKo:
                    '- Les tests doivent contenir au moins un test OK et un test KO',
                  interdictionValidation:
                    "<span><span class='material-icons' aria-hidden='true'>close</span> Attention, vous ne pouvez pas valider l'étape.<br /> Si dessous la liste des erreurs et les TransId correspondants à chaque test en erreur :</span>"
                }
              }
            },
            TERMINAL_LOCATION_PUSH_TEST: {
              timelineTitle: 'Test Push',
              title: 'Test du Terminal location push',
              htmlExplanation:
                "Veuillez générer un push depuis notre plateforme en utilisant le formulaire ci-dessous.<br /><br />La liste des logs se rafraichit automatiquement mais vous pouvez forcer l'actualisation en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              htmlStepUnauthorized:
                "Le test Push est réalisé par le Psap ou l'intégrateur affecté à ce Psap.<br />Veuillez patienter jusqu'à la validation de l'étape.",
              form: {
                testSectionTitle: "Envoi d'un test Terminal Location Push",
                url: 'URL du webservice Psap',
                'url.placeholder': "Indiquez l'URL",
                'url.helper':
                  "Indiquez l'URL du webservice pour recevoir le Terminal Location Push",
                testType: 'Type de localisation',
                'testType.helper':
                  'Choisissez le type de test que vous souhaitez lancer',
                ellipsePos: 'Position',
                ellipsePosPlaceholder: { placeholder: 'Indiquez la position' },
                'ellipsePos.helper':
                  'Indiquez la position sous forme de deux nombres décimaux séparés par un espace',
                ellipseSemiMajorAxis: 'Semi major axis',
                ellipseSemiMajorAxisPlaceholder: 'Indiquez le semi major axis',
                'ellipseSemiMajorAxis.helper':
                  "Indiquez le semi major axis sous forme d'un nombre décimal",
                ellipseSemiMinorAxis: 'Semi minor axis',
                ellipseSemiMinorAxisPlaceholder: 'Indiquez le semi minor axis',
                'ellipseSemiMinorAxis.helper':
                  "Indiquez le semi minor axis sous forme d'un nombre décimal",
                ellipseOrientation: 'Orientation',
                ellipseOrientationPlaceholder: "Indiquez l'orientation",
                'ellipseOrientation.helper':
                  "Indiquez l'orientation sous forme d'un nombre décimal",
                polygonPos: 'Liste de positions',
                polygonPosPlaceholder: 'Indiquez une position',
                'polygonPos.helper':
                  'Indiquez la position sous forme de deux nombres décimaux séparés par un espace',
                addPosition: 'Ajouter une position',
                'addPosition.helper': 'Ajouter une position à la liste',
                removePosition: 'Supprimer',
                'removePosition.helper': 'Supprimer cette position de la liste',
                arcbandPos: 'Position',
                arcbandPosPlaceholder: 'Indiquez la position',
                'arcbandPos.helper':
                  'Indiquez la position sous forme de deux nombres décimaux séparés par un espace',
                arcbandInnerRadius: 'Inner radius',
                arcbandInnerRadiusPlaceholder: "Indiquez l'inner radius",
                'arcbandInnerRadius.helper':
                  "Indiquez l'inner radius sous forme d'un nombre décimal",
                arcbandOuterRadius: 'Outer radius',
                arcbandOuterRadiusPlaceholder: "Indiquez l'outer radius",
                'arcbandOuterRadius.helper':
                  "Indiquez l'outer radius sous forme d'un nombre décimal",
                arcbandStartAngle: 'Start angle',
                arcbandStartAnglePlaceholder: 'Indiquez le start angle',
                'arcbandStartAngle.helper':
                  "Indiquez le start angle sous forme d'un nombre décimal",
                arcbandOpeningAngle: 'Opening angle',
                arcbandOpeningAnglePlaceholder: "Indiquez l'opening angle",
                'arcbandOpeningAngle.helper':
                  "Indiquez l'opening angle sous forme d'un nombre décimal",
                buttonSelectPreset: 'Jeux de valeurs',
                'buttonSelectPreset.helper':
                  'Choisissez un jeu de valeurs donné ou saisissez-les manuellement',
                button: 'Lancer le test'
              },
              messages: {
                validate: {
                  url: {
                    required: "Veuillez indiquer l'URL du webservice",
                    invalid: 'Veuillez indiquer une URL correcte'
                  },
                  testType: {
                    required: 'Veuillez choisir un type de localisation'
                  },
                  ellipsePos: {
                    required: 'Veuillez indiquer la position',
                    invalid:
                      'Veuillez indiquer deux nombres séparés par un espace'
                  },
                  ellipseSemiMajorAxis: {
                    required: 'Veuillez indiquer le semi major axis',
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  ellipseSemiMinorAxis: {
                    required: 'Veuillez indiquer le semi minor axis',
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  ellipseOrientation: {
                    required: "Veuillez indiquer l'orientation",
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  polygonPos: {
                    required: 'Veuillez indiquer la position',
                    invalid:
                      'Veuillez indiquer deux nombres séparés par un espace'
                  },
                  arcbandPos: {
                    required: 'Veuillez indiquer la position',
                    invalid:
                      'Veuillez indiquer deux nombres séparés par un espace'
                  },
                  arcbandInnerRadius: {
                    required: "Veuillez indiquer l'inner radius",
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  arcbandOuterRadius: {
                    required: "Veuillez indiquer l'outer radius",
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  arcbandStartAngle: {
                    required: 'Veuillez indiquer le start angle',
                    invalid: 'Veuillez indiquer un nombre décimal'
                  },
                  arcbandOpeningAngle: {
                    required: "Veuillez indiquer l'opening angle",
                    invalid: 'Veuillez indiquer un nombre décimal'
                  }
                },
                success: {
                  testSend: 'La requête a été envoyée avec succès.',
                  lastTestOk:
                    "<span><span class='material-icons' aria-hidden='true'>check</span> Le dernier test effectué est réussi. Vous pouvez valider l'étape.</span>",
                  alreadyValidated:
                    'Cette étape à déjà été validée avec un test réussi.'
                },
                warning: {
                  lastTestKo:
                    "<span><span class='material-icons' aria-hidden='true'>close</span> Le dernier test doit avoir le statut 'OK' afin de passer à l'étape suivante.</span>"
                },
                error: {
                  presetsLoadFail:
                    'Impossible de charger les presets de tests. Veuillez réessayer.',
                  testSendFail:
                    'Une erreur est survenue pendant la génération du test. Veuillez réessayer.'
                }
              },
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              }
            },
            TERMINAL_LOCATION_PULL_TEST: {
              timelineTitle: 'Test Pull',
              title: 'Test du Terminal location pull',
              htmlExplanation:
                "Veuillez envoyer un pull depuis votre plateforme puis actualiser la liste des logs ci-dessous en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              htmlStepUnauthorized:
                "Le test Pull est réalisé par le Psap ou l'intégrateur affecté à ce Psap.<br />Veuillez patienter jusqu'à la validation de l'étape.",
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                success: {
                  alreadyValidated: 'Cette étape à déjà été validée',
                  lastTestOk: '- Le dernier test effectué est réussi',
                  transIdUnique:
                    '- La valeur de TransId est différente pour chaque test',
                  transIdValid: '- Les TransId respectent la bonne syntaxe',
                  dateEnvoiReceptionReqValid:
                    "- Ecart de moins de 10s entre l'horaire de l'appel du service pull et l'horaire de réception effectif",
                  OkAndKo: '- Il existe au moins un test OK et un test KO',
                  PermissionValidation:
                    "<span><span class='material-icons' aria-hidden='true'>check</span> Vous pouvez valider l'étape</span>"
                },
                warning: {
                  lastTestKo: "- Le dernier test doit avoir le statut 'OK'",
                  transIdNotUnique:
                    '- Le TransId doit avoir des valeurs différentes pour chaque test',
                  transIdNotValid:
                    "- Ces TransId ne respectent pas la bonne syntaxe. Pour plus d'informations à propos du TransId, veuillez consulter la <a href='#/faq#syntaxeTransId'>FAQ</a>",
                  dateEnvoiReceptionReqNotValid:
                    "- Un écart de plus de 10s entre<br />--> <strong>Date requête (UTC)</strong> correspondant à la date que vous envoyez lors de l'appel du service pull<br /> --> et <strong>Date serveur PFLAU (UTC)</strong> correspondant à la date de réception effective de la requête.<br /> Merci de verifier l'heure que vous envoyez lors de l'appel du service pull.",
                  OkAndKo:
                    '- Les tests doivent contenir au moins un test OK et un test KO',
                  interdictionValidation:
                    "<span><span class='material-icons' aria-hidden='true'>close</span> Attention, vous ne pouvez pas valider l'étape.<br /> Si dessous la liste des erreurs et les TransId correspondants à chaque test en erreur :</span>"
                }
              }
            },
            RECEVABILITY_AGREEMENT_WORLDLINE: {
              timelineTitle: 'Validation Worldline',
              title: 'Validation Worldline',
              htmlStepUnauthorized:
                'Cette étape est réalisée par Worldline.<br />Vos contacts technique et projet seront notifiés par mail une fois la recevabilité terminée.'
            },
            RECEVABILITY_AGREEMENT_APNF: {
              timelineTitle: 'Validation APNF',
              title: 'Validation APNF',
              htmlStepUnauthorized:
                "Cette étape est réalisée par l'APNF.<br />Vos contacts technique et projet seront notifiés par mail une fois la recevabilité terminée.",
              htmlSvh:
                "Si l'intégrateur souhaite ne faire qu'une recevabilité pour plusieurs PSAPs, veuillez sélectionner les PSAPs qui seront intégrés avec strictement les mêmes données techniques que le PSAP"
            },
            GOING_INTO_PRODUCTION: {
              timelineTitle: 'Mise en production',
              title: 'Mise en production',
              htmlStepUnauthorized:
                'Cette étape est réalisée par Worldline.<br />Vos contacts technique et projet seront notifiés par mail une fois la recevabilité terminée.',
              htmlSvh:
                'Liste des PSAPs dont on veut les requêtes pour les passer en production :'
            }
          }
        },
        operator: {
          one: {
            title: "Recevabilité de l'opérateur"
          },
          mine: {
            title: "Recevabilité de l'opérateur"
          },
          messages: {
            validate: {
              toNextStage: {
                mustValidateCurrent:
                  "Veuillez d'abord valider cette étape avant de passer à la suivante."
              }
            },
            success: {
              recevabilityValidated:
                "Vous avez bien validé la dernière étape de la recevabilité de l'opérateur {{name}}."
            },
            info: {
              recevabilityAlreadyDone:
                "Les étapes de recevabilité de l'opérateur {{name}} sont terminées. Vous pouvez seulement les consulter."
            },
            error: {
              arcepOperatorIdNotFound: 'Accès non autorisé',
              operatorNotExists: "L'opérateur {{name}} n'existe pas",
              stagesLoadFail:
                'Un problème est survenu durant le chargement des étapes de recevabilité. Veuillez réessayer.',
              operatorLoadFail:
                "Un problème est survenu durant le chargement des informations de l'opérateur {{name}}. Veuillez réessayer.",
              recevabilityLoadFail:
                "Un problème est survenu durant le chargement de la recevabilité de l'opérateur {{name}}. Veuillez réessayer. (#202)",
              recevabilityLoadFailAfterCreate:
                "Un problème est survenu durant le chargement de la recevabilité de l'opérateur {{name}}. Veuillez réessayer. (#201)",
              noRecevabilityInProgress:
                "L'opérateur {{name}} n'est pas en cours de recevabilité. Vous devez d'abord initialiser le processus.",
              cannotRemoveRecevability:
                "Vous avez bien validé la dernière étape de la recevabilité de l'opérateur {{name}}. (#200)",
              cannotValidateCurrentStage:
                "Un problème est survenu pour passer à l'étape suivante. Veuillez réessayer."
            }
          },
          step: {
            VPN_CONFIG_WAITING: {
              timelineTitle: 'Infos VPN',
              title: 'Informations VPN',
              htmlExplanation:
                "Veuillez renseigner les coordonnées du contact projet et du contact technique. Remplissez ensuite les informations demandées sur les caractéristiques du VPN à mettre en place. <a href='api/getDocFile?file=Fiche_d_interconnexion_VPN-PFLAU' target='_blank'><span class='material-icons'>save_alt</span>Télécharger le fichier d'interconnexion VPN</a><br />Terminez ensuite en indiquant les URL d'accès aux pages de tests puis valider le formulaire pour les envoyer à Worldline.",
              form: {
                projectContactSectionTitle:
                  'Coordonnées du contact projet (MOA)',
                projectContactName: 'Nom',
                'projectContactName.placeholder': 'Nom du contact projet',
                projectContactPhone: 'Téléphone',
                'projectContactPhone.placeholder':
                  'Téléphone du contact projet',
                projectContactFax: 'Fax (facultatif)',
                'projectContactFax.placeholder': 'Fax du contact projet',
                'projectContactFax.empty': '-',
                projectContactMail: 'Email',
                'projectContactMail.placeholder': 'Email du contact projet',
                technicalContactSectionTitle:
                  'Coordonnées du contact technique',
                technicalContactName: 'Nom',
                'technicalContactName.placeholder': 'Nom du contact technique',
                technicalContactPhone: 'Téléphone',
                'technicalContactPhone.placeholder':
                  'Téléphone du contact technique',
                technicalContactFax: 'Fax (facultatif)',
                'technicalContactFax.placeholder': 'Fax du contact technique',
                'technicalContactFax.empty': '-',
                technicalContactMail: 'Email',
                'technicalContactMail.placeholder':
                  'Email du contact technique',
                technicalInfosSectionTitle: 'Informations techniques',
                technicalInfosVpnTerminaison: 'Equipement de terminaison VPN',
                'technicalInfosVpnTerminaison.placeholder':
                  'Nom de votre équipement',
                'technicalInfosVpnTerminaison.helper':
                  "Il peut s'agir par exemple d'un CISCO ASA",
                technicalInfosEndOfTunnelPeer: 'Ip V4 publique du tunnel',
                'technicalInfosEndOfTunnelPeer.placeholder':
                  'Ip V4 publique de votre équipement',
                'technicalInfosEndOfTunnelPeer.helper':
                  "Il s'agit d'une Ip V4 publique",
                technicalInfosEncryptedDomain: 'Domaine du cryptage',
                'technicalInfosEncryptedDomain.placeholder':
                  'Domaine de cryptage',
                'technicalInfosEncryptedDomain.helper':
                  'Ip du domaine de cryptage',
                technicalInfosEncryptedMask:
                  'Masque de sous-domaine du cryptage',
                'technicalInfosEncryptedMask.placeholder':
                  'Masque de sous-domaine du cryptage',
                'technicalInfosEncryptedMask.helper':
                  'Masque de sous-domaine du cryptage',
                ikeSectionTitle: 'Phase 1 - Paramètres IKE',
                ikeAuthentMode: "Mode d'authentification",
                'ikeAuthentMode.placeholder': "Mode d'authentification",
                'ikeAuthentMode.helper': 'Valeur recommandée : PreSharedKey',
                'ikeAuthentMode.ahead': 'PreSharedKey',
                ikeAuthentAlgo: "Algorithme d'authentification",
                'ikeAuthentAlgo.placeholder': "Algorithme d'authentification",
                'ikeAuthentAlgo.helper': 'Valeur recommandée : SHA256',
                'ikeAuthentAlgo.ahead': 'SHA256',
                ikeEncryptAlgo: 'Algorithme de cryptage',
                'ikeEncryptAlgo.placeholder': 'Algorithme de cryptage',
                'ikeEncryptAlgo.helper':
                  'Valeur recommandée : AES128 ou AES256',
                'ikeEncryptAlgo.ahead': 'AES128,AES256',
                ikeDiffieHellmannGroup: 'Groupe Diffie-Hellmann',
                'ikeDiffieHellmannGroup.placeholder':
                  'Nom du groupe Diffie-Hellmann',
                'ikeDiffieHellmannGroup.helper': 'Valeur recommandée : Group 2',
                'ikeDiffieHellmannGroup.ahead': 'Group 2',
                ikeLifetime: 'Durée de validité (secondes)',
                'ikeLifetime.placeholder': 'Durée de validité',
                'ikeLifetime.helper':
                  'Valeur recommandée : 86400 (soit 24 heures)',
                ikeEncryptionScheme: "Méthode d'authentification",
                'ikeEncryptionScheme.placeholder': "Méthode d'authentification",
                'ikeEncryptionScheme.helper': 'Valeur recommandée : IKE V2.0',
                'ikeEncryptionScheme.ahead': 'IKE V1.0',
                ikeNegotiationMode: 'Mode de négociation',
                'ikeNegotiationMode.placeholder': 'Mode de négociation',
                'ikeNegotiationMode.helper': 'Valeur recommandée : Main mode',
                'ikeNegotiationMode.ahead': 'Main mode',
                isakmpSectionTitle: 'Phase 2 - Paramètres ISAKMP',
                isakmpEncryptProtocol: 'Protocol de cryptage',
                'isakmpEncryptProtocol.placeholder': 'Protocol de cryptage',
                'isakmpEncryptProtocol.helper':
                  'Valeur recommandée : AES128 ou AES256',
                'isakmpEncryptProtocol.ahead': 'AES128,AES256',
                isakmpHashAlgo: 'Algorithme de hash',
                'isakmpHashAlgo.placeholder': 'Algorithme de hash',
                'isakmpHashAlgo.helper': 'Valeur recommandée : SHA-256',
                'isakmpHashAlgo.ahead': 'SHA-256',
                isakmpAuthentAlgo: "Algorithme d'authentification",
                'isakmpAuthentAlgo.placeholder':
                  "Algorithme d'authentification",
                'isakmpAuthentAlgo.helper': 'Valeur recommandée : SHA256',
                'isakmpAuthentAlgo.ahead': 'SHA256',
                isakmpEncryptAlgo: 'Algorithme de cryptage',
                'isakmpEncryptAlgo.placeholder': 'Algorithme de cryptage',
                'isakmpEncryptAlgo.helper':
                  'Valeur recommandée : AES128 ou AES256',
                'isakmpEncryptAlgo.ahead': 'AES128,AES256',
                isakmpEncapsulationMode: "Mode d'encapsulation",
                'isakmpEncapsulationMode.placeholder': "Mode d'encapsulation",
                'isakmpEncapsulationMode.helper':
                  'Valeur recommandée : Mode tunnel',
                'isakmpEncapsulationMode.ahead': 'Mode tunnel',
                isakmpPerfectForwardSecrecy: 'Confidentialité persistante',
                'isakmpPerfectForwardSecrecy.true':
                  'Oui, utiliser la confidentialité persistante',
                'isakmpPerfectForwardSecrecy.false':
                  'Non, je ne souhaite pas utiliser la confidentialité persistante',
                'isakmpPerfectForwardSecrecy.helper': 'Recommandé',
                isakmpPfsGroup: 'Utiliser le groupe PFS',
                'isakmpPfsGroup.true': 'Oui, utiliser le groupe PFS',
                'isakmpPfsGroup.false':
                  'Non, je ne souhaite pas utiliser le groupe PFS',
                'isakmpPfsGroup.helper': 'Valeur recommandée : 2',
                isakmpKeyLifetime: 'Durée de vie de la clé',
                'isakmpKeyLifetime.placeholder': 'Durée de vie en secondes',
                'isakmpKeyLifetime.helper':
                  'Valeur recommandée : 28800 (soit 8 heures)',
                otherSectionTitle: 'Instructions',
                comments: 'Commentaires utiles',
                commentsPlaceholder: {
                  placeholder: 'Indiquez ici tout commentaire utile'
                },
                'comments.helper':
                  'Indiquez tout ce qui peut être utile pour la mise en place du VPN',
                testUrlSectionTitle: 'URL des pages de test',
                qualifTestUrl: 'URL de la page de test en qualification',
                'qualifTestUrl.placeholder':
                  'Indiquez le lien vers la page de test',
                'qualifTestUrl.helper': '',
                prodTestUrl: 'URL de la page de test en production',
                'prodTestUrl.placeholder':
                  'Indiquez le lien vers la page de test',
                'prodTestUrl.helper': ''
              },
              messages: {
                validate: {
                  projectContactName: {
                    required: 'Veuillez indiquer le nom du contact projet',
                    invalid: 'Veuillez indiquer un nom plus court'
                  },
                  projectContactPhone: {
                    required:
                      'Veuillez indiquer le téléphone du contact projet',
                    invalid:
                      'Veuillez indiquer un téléphone au format 0123456789 ou +33123456789'
                  },
                  projectContactFax: {
                    invalid:
                      'Veuillez indiquer un fax au format 0123456789 ou +33123456789'
                  },
                  projectContactMail: {
                    required:
                      "Veuillez indiquer l'adresse email du contact projet",
                    invalid: 'Veuillez indiquer une adresse email correcte'
                  },
                  technicalContactName: {
                    required: 'Veuillez indiquer le nom du contact technique',
                    invalid: 'Veuillez indiquer un nom plus court'
                  },
                  technicalContactPhone: {
                    required:
                      'Veuillez indiquer le téléphone du contact technique',
                    invalid:
                      'Veuillez indiquer un téléphone au format 0123456789 ou +33123456789'
                  },
                  technicalContactFax: {
                    invalid:
                      'Veuillez indiquer un fax au format 0123456789 ou +33123456789'
                  },
                  technicalContactMail: {
                    required:
                      "Veuillez indiquer l'adresse email du contact technique",
                    invalid: 'Veuillez indiquer une adresse email correcte'
                  },
                  technicalInfosVpnTerminaison: {
                    required:
                      'Veuillez saisir votre équipement de terminaison VPN'
                  },
                  technicalInfosEndOfTunnelPeer: {
                    required:
                      "Veuillez saisir l'Ip publique pour accéder à votre équipement",
                    invalid:
                      'Veuillez saisir une Ip valide comme par exemple 123.123.12.12'
                  },
                  technicalInfosEncryptedDomain: {
                    required: 'Veuillez sélectionner le domaine du cryptage',
                    invalid:
                      'Veuillez saisir un range Ip valide comme par exemple 123.123.12.12'
                  },
                  technicalInfosEncryptedMask: {
                    required:
                      'Veuillez sélectionner le masque de sous-domaine du cryptage',
                    invalid:
                      'Veuillez saisir un masque valide comme par exemple 255.255.224.0'
                  },
                  ikeAuthentMode: {
                    required: "Veuillez saisir le mode d'authentification"
                  },
                  ikeAuthentAlgo: {
                    required: "Veuillez saisir l'algorithme d'authentification"
                  },
                  ikeEncryptAlgo: {
                    required: "Veuillez saisir l'algorithme de cryptage"
                  },
                  ikeDiffieHellmannGroup: {
                    required: 'Veuillez saisir le groupe Diffie-Hellmann'
                  },
                  ikeLifetime: {
                    required: 'Veuillez saisir la durée de validité (secondes)',
                    invalid:
                      'Veuillez saisir une durée de validité inférieure à 48h (172800 secondes)'
                  },
                  ikeEncryptionScheme: {
                    required: "Veuillez saisir la méthode d'authentification"
                  },
                  ikeNegotiationMode: {
                    required: 'Veuillez saisir le mode de négociation'
                  },
                  isakmpEncryptProtocol: {
                    required: 'Veuillez saisir le protocol de cryptage'
                  },
                  isakmpHashAlgo: {
                    required: "Veuillez saisir l'algorithme de hash"
                  },
                  isakmpAuthentAlgo: {
                    required: "Veuillez saisir l'algorithme d'authentification"
                  },
                  isakmpEncryptAlgo: {
                    required: "Veuillez saisir l'algorithme de cryptage"
                  },
                  isakmpEncapsulationMode: {
                    required: "Veuillez saisir le mode d'encapsulation"
                  },
                  isakmpKeyLifetime: {
                    required:
                      'Veuillez saisir la durée de vie de la clé (secondes)',
                    invalid:
                      'Veuillez saisir une durée de vie inférieure à 24h (86400 secondes)'
                  },
                  qualifTestUrl: {
                    required:
                      "Veuillez saisir l'adresse https d'accès à la page de test de qualification",
                    invalid:
                      'Veuillez saisir une adresse https correcte. \nexemple: https://mondomaine.fr/chemin/vers/la/page.html'
                  },
                  prodTestUrl: {
                    required:
                      "Veuillez saisir l'adresse https d'accès à la page de test de production",
                    invalid:
                      'Veuillez saisir une adresse https correcte. \nexemple: https://mondomaine.fr/chemin/vers/la/page.html'
                  }
                },
                info: {
                  xx: 'xx'
                },
                error: {
                  vpnInfoLoadFail:
                    'Une erreur est survenue lors du chargement du formulaire. Veuillez réessayer dans un moment',
                  formInvalid:
                    'Veuillez vérifier les données saisies dans le formulaire'
                },
                success: {
                  formValidated:
                    "Les informations VPN ont bien été enregistrées. Passage à l'étape suivante."
                }
              }
            },
            PRESHARED_KEY_WAITING: {
              timelineTitle: 'PSK',
              title: 'Récupération de la PSK',
              button: 'Générer la clef',
              messagePre:
                "ATTENTION la PreSharedKey est générée de façon unique et n'est pas stockée au sein du service PFLAU.</br>Veillez à noter et conserver cette clef. En cas de perte, nous ne pourrons pas vous la communiquer à nouveau.<br />Une nouvelle clef pourra néanmoins être générée en contactant l'équipe technique PFLAU.",
              messagePost:
                'Votre clef a été générée et partagée avec Worldline.',
              pskGenerationError: "La clef n'a pas pu être générée."
            },
            WL_VPN_CONFIG_WAITING: {
              timelineTitle: 'CONFIG VPN',
              title: 'Configuration VPN côté Worldline',
              message:
                "Cette étape est réalisée par Worldline.<br />Vos contacts technique et projet seront notifiés par mail une fois l'étape terminée."
            },
            VPN_TEST_WAITING: {
              timelineTitle: 'Test VPN Opérateur',
              title: 'Test du VPN côté Opérateur',
              message:
                "Le test de connexion consiste à valider le montage du tunnel :<br /><ul><li>jusqu'à l'applicatif PFLAU de qualification via l'url <a href=\"https://qlf-pflau-push.aw.atos.net/pushLocation?wsdl\">https://qlf-pflau-push.aw.atos.net/pushLocation?wsdl</a></li><li>jusqu'à l'applicatif PFLAU de production via l'url <a href=\"https://pflau-push.aw.atos.net/pushLocation?wsdl\">https://pflau-push.aw.atos.net/pushLocation?wsdl</a></li></ul><br />Merci d'effectuer 2 hits via le VPN : 1 sur chaque page de test applicative de qualification/production.<br />Cette étape sera validée par Worldline dès lors qu'une connexion réussie via le VPN aura été constatée en qualification et en production."
            },
            WL_VPN_TEST_WAITING: {
              timelineTitle: 'Test VPN Worldline',
              title: 'Test du VPN côté Worldline',
              message:
                "Worldline va désormais procéder aux tests de connexion VPN en effectuant des hits sur les pages de qualification/production de l'opérateur.<br />Merci de vous assurer que le tunnel n'est plus monté dans le sens Opérateur vers Worldline.<br /><br />Cette étape sera validée par Worldline dès lors qu'une connexion réussie via le VPN aura été constatée en qualification et en production."
            },
            PUSHLOCATION_TEST_WAITING: {
              timelineTitle: 'Test PUSH',
              title: 'Test du Push Location',
              htmlExplanation:
                "Veuillez envoyer un push depuis votre plateforme puis actualiser la liste des logs ci-dessous en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                success: {
                  lastTestOk:
                    "Le dernier test effectué est réussi. Vous pouvez valider l'étape.",
                  alreadyValidated:
                    'Cette étape à déjà été validée avec un test réussi.'
                },
                warning: {
                  lastTestKo:
                    "Le dernier test doit avoir le statut 'OK' afin de passer à l'étape suivante."
                }
              }
            },
            PUSHLOCATIONSVH_TEST_WAITING: {
              timelineTitle: 'Test PUSH SVH',
              title: 'Test du Push Location SVH',
              htmlExplanation:
                "Veuillez envoyer un push SVH depuis votre plateforme puis actualiser la liste des logs ci-dessous en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                success: {
                  lastTestOk:
                    "Le dernier test effectué est réussi. Vous pouvez valider l'étape.",
                  alreadyValidated:
                    'Cette étape à déjà été validée avec un test réussi.'
                },
                warning: {
                  lastTestKo:
                    "Le dernier test doit avoir le statut 'OK' afin de passer à l'étape suivante."
                }
              }
            },
            GETADDRESS_TEST_WAITING: {
              timelineTitle: 'Test Get Address',
              title: 'Test du Get Address',
              htmlExplanation:
                'Veuillez générer un getAddress depuis notre plateforme en utilisant le formulaire ci-dessous.<br />',
              htmlExplanationEnd:
                "<br />La liste des logs se rafraichit automatiquement mais vous pouvez forcer l'actualisation en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              htmlExplanationEndSvh:
                "<br />La liste des logs se rafraichit automatiquement mais vous pouvez forcer l'actualisation en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Les 2 derniers tests doivent être un test getAddress ET un test getAddressSVH avec le statut 'OK' afin de valider l'étape.</strong>",
              form: {
                button: 'Envoyer la requête'
              },
              formModify: {
                button: 'Mettre à jour'
              },
              logViewer: {
                title: 'Logs',
                titleSvh: 'Logs SVH de la journée',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  psapId: 'PsapId',
                  ndi: 'Ndi',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                error: {
                  testSend:
                    "Une erreur est survenue lors de l'envoi de la requête de getAddress.",
                  testSendSVH:
                    "Une erreur est survenue lors de l'envoi de la requête de getAddressSVH."
                },
                success: {
                  testSend: 'La requête getAddress a été envoyée avec succès.',
                  testSendSVH:
                    'La requête getAddressSVH a été envoyée avec succès.',
                  lastTestOk:
                    "Le dernier test effectué est réussi. Vous pouvez valider l'étape.",
                  lastTestOkSVH:
                    "Les 2 derniers tests sont bien des tests getAddress et getAddressSVH et ils sont réussis. Vous pouvez valider l'étape.",
                  alreadyValidated:
                    'Cette étape à déjà été validée avec un test réussi.'
                },
                warning: {
                  lastTestKo:
                    "Le dernier test doit avoir le statut 'OK' afin de passer à l'étape suivante.",
                  lastTestKoSVH:
                    "Les 2 derniers tests doivent être un test getAddress ET un test getAddressSVH avec le statut 'OK' afin de passer à l'étape suivante."
                }
              },
              messagesModify: {
                error: {
                  testSend:
                    "Une erreur est survenue lors de la mise à jour de l'URL de getAddress.",
                  testSendSVH:
                    "Une erreur est survenue lors de la mise à jour de l'URL de getAddressSVH."
                },
                success: {
                  testSend:
                    "La mise à jour de l'URL de getAddress a été réalisée avec succès.",
                  testSendSVH:
                    "La mise à jour de l'URL de getAddressSVH a été réalisée avec succès."
                }
              },
              modifyAddress: "Mettre à jour l'URL de getAddress",
              modifyAddressSVH: "Mettre à jour l'URL de getAddressSVH"
            },
            GETLOCATIONSVH_TEST_WAITING: {
              timelineTitle: 'Test Get Location SVH',
              title: 'Test du Get Location SVH',
              htmlExplanation:
                'Veuillez générer un getLocationSvh depuis notre plateforme en utilisant le formulaire ci-dessous.<br />',
              htmlExplanationEnd:
                "<br />La liste des logs se rafraichit automatiquement mais vous pouvez forcer l'actualisation en cliquant sur le bouton <span class='material-icons'>sync</span>.<br /><strong>Le dernier test effectué doit avoir le statut 'OK' afin de valider l'étape.</strong>",
              form: {
                button: 'Envoyer la requête'
              },
              formModify: {
                button: 'Mettre à jour'
              },
              logViewer: {
                title: 'Logs',
                headers: {
                  dateTimeUTC: 'Date requête (UTC)',
                  dateTimeIn: 'Date serveur PFLAU (UTC)',
                  function: 'Type',
                  duration: 'Durée',
                  idTransaction: 'TransId',
                  psapPhone: 'PsapPhone',
                  psapId: 'PsapId',
                  ndi: 'Ndi',
                  statut: 'Statut',
                  codeErreur: 'Err n°',
                  descErreur: 'Err description',
                  lienSoap: 'Lien Soap'
                }
              },
              messages: {
                error: {
                  testSend:
                    "Une erreur est survenue lors de l'envoi de la requête de getLocationSvh."
                },
                success: {
                  testSend:
                    'La requête getLocationSvh a été envoyée avec succès.',
                  lastTestOk:
                    "Le dernier test effectué est réussi. Vous pouvez valider l'étape.",
                  alreadyValidated:
                    'Cette étape à déjà été validée avec un test réussi.'
                },
                warning: {
                  lastTestKo:
                    "Le dernier test doit avoir le statut 'OK' afin de passer à l'étape suivante."
                }
              },
              messagesModify: {
                error: {
                  testSend:
                    "Une erreur est survenue lors de la mise à jour de l'URL de getAddress."
                },
                success: {
                  testSend:
                    "La mise à jour de l'URL de getLocationSvh a été réalisée avec succès."
                }
              },
              modifyAddress: "Mettre à jour l'URL de getLocationSvh"
            },
            NOTIFYOPERATOR_TEST_WAITING: {
              timelineTitle: 'Test Notify',
              title: 'Test du Notify Operator',
              htmlExplanation:
                "Veuillez générer un notifyOperator depuis notre plateforme en cliquant sur le bouton ci-dessous.<br />Une fois la requête reçue, vous pouvez valider l'étape.",
              form: {
                button: 'Envoyer la requête'
              },
              messages: {
                error: {
                  testSend:
                    "Une erreur est survenue lors de l'envoi de la requête de notification."
                },
                success: {
                  testSend:
                    "La requête de notification a été envoyée avec succès. Merci de vérifier qu'elle vous est bien parvenue avant de passer à l'étape suivante."
                }
              }
            },
            RECEVABILITY_AGREEMENT_WORLDLINE: {
              timelineTitle: 'Validation Worldline',
              title: 'Validation Worldline',
              message:
                'Cette étape est réalisée par Worldline.<br />Vos contacts technique et projet seront notifiés par mail une fois la recevabilité terminée.'
            },
            RECEVABILITY_AGREEMENT_APNF: {
              timelineTitle: 'Validation APNF',
              title: 'Validation APNF',
              message:
                "Cette étape est réalisée par l'APNF.<br />Vos contacts technique et projet seront notifiés par mail une fois la recevabilité terminée."
            }
          }
        }
      },
      'event-info': 'Informations',
      'event-meteo': 'Météo',
      eventList: {
        title: 'Liste des évènements'
      },
      newEvent: {
        title: 'Créer un évènement'
      },
      'event-detail': {
        title: 'Modifier un évènement'
      },
      'horairesSVH-detail': {
        title: 'Modifier un horaire'
      },
      auth: {
        login: {
          required: 'Le login est requis.',
          min_length: 'Le login doit avoir au moins 4 caractères.',
          max_length: 'Le login ne doit pas  avoir plus que 32 caractères.',
          pattern: 'Le login doit contenir chiffre, lettre et _-'
        },
        passwd: {
          required: 'Le mot de passe est obligatoire.',
          req_min_length:
            'Le mot de passe est obligatoire et doit avoir au minimum 12 caractères.',
          min_length: 'Le mot de passe doit avoir au minimum 12 caractères.',
          max_length: 'Le mot de passe ne peut avoir plus de 16 caractères.',
          pattern:
            "{'Le mot de passe doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère parmi #?!@$%^&*- .'}"
        },
        forgetpwd: 'Oubli de mot de passe',
        reinit:
          "Veuillez renseigner votre nom d'utilisateur et l'adresse mail associée afin de réinitialiser votre mot de passe.",
        usernamepattern: 'Le login doit contenir chiffre, lettre et _-',
        email: {
          required: "L'email est requis.",
          invalid: "L'email est invalide."
        }
      },
      toast: {
        title: {
          success: 'Succès',
          fail: 'Echec'
        }
      }
    },
    en: en
  }
})
